import { combineEpics } from 'redux-observable'
import { LoadBillingEpic } from './LoadBillingEpic.js'
import { ReloadCreditsEpic } from './ReloadCreditsEpic.js'

export const billingEpics = combineEpics(LoadBillingEpic, ReloadCreditsEpic)
